import React from 'react';

// Reusable Logo Component
export function Logo({ variant = 'full', className = '', height = 40 }) {
  const logoSrc = '/images/scratch-logo.png';
  
  if (variant === 'icon') {
    // Just the dragon icon (cropped version for nav)
    return (
      <img 
        src={logoSrc}
        alt="Scratch Unleashed"
        className={`object-contain ${className}`}
        style={{ 
          height: `${height}px`,
          width: 'auto',
          objectPosition: 'center top',
          filter: 'brightness(1.05) saturate(0.95)' // Subtle matte effect
        }}
      />
    );
  }
  
  // Full logo
  return (
    <img 
      src={logoSrc}
      alt="Scratch Unleashed"
      className={`object-contain ${className}`}
      style={{ 
        height: `${height}px`,
        width: 'auto',
        filter: 'brightness(1.05) saturate(0.95)' // Subtle matte effect
      }}
    />
  );
}
